import { createAction } from 'redux-actions';

export const SELECTED_VIDEO_ACTIONS = {
  SET: 'CLIENT.SELECTED_VIDEO.SET',
  RESET: 'CLIENT.SELECTED_VIDEO.RESET',
};

export const selectVideo = createAction(SELECTED_VIDEO_ACTIONS.SET);
export const resetSelectedVideo = createAction(SELECTED_VIDEO_ACTIONS.RESET);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/select-video.js